import { Inject, Injectable, DOCUMENT } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { LoggingLevel } from './logging.service.constants';

const handleErrorLevel = () => true;
const handleWarnLevel = (l: LoggingLevel) =>
  l === LoggingLevel.warn || l === LoggingLevel.trace;
const handleTraceLevel = (l: LoggingLevel) => l === LoggingLevel.trace;

@Injectable({
  providedIn: 'root',
})
export class Logging {
  env: string;

  private logLevelForInstance: LoggingLevel = this.environment.logLevel
    ? LoggingLevel[this.environment.logLevel as keyof typeof LoggingLevel]
    : LoggingLevel.warn;

  private envs: { [domain: string]: string } = {
    localhost: 'local',
    thesmartflip: 'prod',
  };

  private getTimestamp(): string {
    return new Date().toISOString();
  }

  private formatMessage(level: LoggingLevel, message: string): string {
    return `${LoggingLevel[level].toUpperCase()} at: ${this.getTimestamp()} in Environment: ${this.env} ${message}`;
  }

  private getEnv(hostname: string) {
    const baseUrl = hostname.replace(/(app\.)|(\.com)/, '');

    return this.envs[baseUrl] ? this.envs[baseUrl] : 'staging';
  }

  private shouldThisLogHappen(level: LoggingLevel) {
    if (this.logLevelForInstance === 'off') return false;

    const l = this.logLevelForInstance;

    if (level === LoggingLevel.error) return handleErrorLevel();
    else if (level === LoggingLevel.warn) return handleWarnLevel(l);
    else if (level === LoggingLevel.trace) return handleTraceLevel(l);
    else return true;
  }

  constructor(
    @Inject(DOCUMENT) private document: any,
    @Inject('environment') private environment: any,
  ) {
    this.env = this.getEnv(this.document.location.hostname as string);
  }
  public localSentryEnabled = true;
  public trace(message: string) {
    if (this.shouldThisLogHappen(LoggingLevel.trace)) {
      const formattedLog = this.formatMessage(LoggingLevel.trace, message);

      console.log(formattedLog);
      Sentry.captureMessage(formattedLog);

      return formattedLog;
    }

    return;
  }

  public warn(message: string) {
    if (this.shouldThisLogHappen(LoggingLevel.warn)) {
      const formattedLog = this.formatMessage(LoggingLevel.warn, message);

      console.warn(formattedLog);
      Sentry.captureMessage(formattedLog);

      return formattedLog;
    }

    return;
  }

  public error(message: string) {
    if (this.shouldThisLogHappen(LoggingLevel.error)) {
      const formattedLog = this.formatMessage(LoggingLevel.error, message);

      console.error(formattedLog);
      Sentry.captureMessage(formattedLog);

      return formattedLog;
    }

    return;
  }
}
